import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MockModeBanner } from './MockModeBanner';
import { CopyrightFooter } from './CopyrightFooter';
import { NardiumHero } from '../hero/NardiumHero';
import { DashboardContent } from '../dashboard/DashboardContent';
import { SwapInterface } from '../swap/SwapInterface';
import { StakingDashboard } from '../staking/StakingDashboard';
import { PortfolioDashboard } from '../portfolio/PortfolioDashboard';
import { SettingsPanel } from '../settings/SettingsPanel';
import { AITradingDashboard } from '../ai-trading/AITradingDashboard';
import { TransactionHistory } from '../transactions/TransactionHistory';
import { AnalyticsDashboard } from '../analytics/AnalyticsDashboard';
import { SecurityDashboard } from '../security/SecurityDashboard';
import { GamificationDashboard } from '../gamification/GamificationDashboard';
import { SocialTradingHub } from '../social-trading/SocialTradingHub';
import { NDHExclusiveHub } from '../exclusive/NDHExclusiveHub';
import { MarketPredictionArena } from '../predictions/MarketPredictionArena';
import { ReferralProgram } from '../referrals/ReferralProgram';
import { TradingBotsManager } from '../trading-bots/TradingBotsManager';
import { InfraVaultHub } from '../infra-vault/InfraVaultHub';
import { InfraBankHub } from '../infrabank/InfraBankHub';
import { NariDeviceConnector } from '../nari/NariDeviceConnector';
// New Smart Features
import { DCADashboard } from '../dca/DCADashboard';
import { WhaleTrackingDashboard } from '../whale-tracking/WhaleTrackingDashboard';
import { MultiWalletDashboard } from '../multi-wallet/MultiWalletDashboard';
import { YieldBoostPanel } from '../staking/YieldBoostPanel';

export type ActiveTab = 'dashboard' | 'swap' | 'staking' | 'portfolio' | 'ai-trading' | 'settings' | 'transactions' | 'analytics' | 'security' | 'gamification' | 'social-trading' | 'ndh-exclusive' | 'predictions' | 'referrals' | 'trading-bots' | 'infra-vault' | 'infrabank' | 'nari' | 'dca' | 'whale-tracking' | 'multi-wallet' | 'yield-boost';

export function MainLayout() {
  const [activeTab, setActiveTab] = useState<ActiveTab>('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <NardiumHero />;
      case 'swap':
        return <SwapInterface />;
      case 'staking':
        return <StakingDashboard />;
      case 'portfolio':
        return <PortfolioDashboard />;
      case 'trading-bots':
        return <TradingBotsManager />;
      case 'ai-trading':
        return <AITradingDashboard />;
      case 'settings':
        return <SettingsPanel />;
      case 'transactions':
        return <TransactionHistory />;
      case 'analytics':
        return <AnalyticsDashboard />;
      case 'security':
        return <SecurityDashboard />;
      case 'gamification':
        return <GamificationDashboard />;
      case 'social-trading':
        return <SocialTradingHub />;
      case 'ndh-exclusive':
        return <NDHExclusiveHub />;
      case 'predictions':
        return <MarketPredictionArena />;
      case 'referrals':
        return <ReferralProgram />;
      case 'infra-vault':
        return <InfraVaultHub />;
      case 'infrabank':
        return <InfraBankHub />;
      case 'nari':
        return <NariDeviceConnector />;
      case 'dca':
        return <DCADashboard />;
      case 'whale-tracking':
        return <WhaleTrackingDashboard />;
      case 'multi-wallet':
        return <MultiWalletDashboard />;
      case 'yield-boost':
        return <YieldBoostPanel currentApy={12.5} stakedAmount="1500" />;
      default:
        return <NardiumHero />;
    }
  };

  return (
    <div className="flex h-screen bg-slate-50 dark:bg-[#0a0a0a]">
      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab}
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <MockModeBanner />
        <Header 
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
        />
        
        <main className="flex-1 overflow-y-auto">
          <div className="p-6">
            <div className="max-w-7xl mx-auto">
              {renderContent()}
            </div>
          </div>
          <CopyrightFooter />
        </main>
      </div>
    </div>
  );
}